<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'user-load-pallets-orders'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top:1em">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <!--
            <button (click)="goToLoadsPage()" class="btn-circle bg-yellow" style="margin-right:1em" >
              <i class="pi pi-arrow-left"></i>
            </button>
          -->
          <h1 class="title-main">{{'UserPages.UserLoadContainersOrders.PageTitle' | translate}}</h1>
        </div>
        <div class="col-12 md:col-6 p-fluid flex align-items-center">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="{{'UserPages.UserLoadOrders.SearchProducts' | translate}}" class="p-inputtext-sm"  [(ngModel)]="searchTerm" (input)="filterLoads()" />
          </span>
        </div>
        <div>
        </div>
      </div>
      <div class="body-card">
        <div class="subtitle-container">
          <h4 class="subtitle">
            {{'UserPages.UserLoadContainersOrders.Exporter' | translate}}
          </h4>
          <button type="button" pButton pRipple
            icon="pi pi-file-excel"
            class="p-button-success mr-2 button-success-style"
            pTooltip="XLS"
            (click)="downloadExcelContainer()"
            tooltipPosition="bottom"
            [loading]="loading"
            [style]="{'width':'fit-content', 'margin-left': '2px'}">
            {{ 'UserPages.UserLoadOrders.ExportExcel' | translate }}
          </button>
        </div>
        <div class="container-filters filters-size">
          <section class="section-info" *ngIf="profile">
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-user" style="margin-right:.5em; color:grey"></i>
                {{companyName}}
              </section>
              <section class="section-data">
                <i class="pi pi-at" style="margin-right:.5em; color:grey"></i>
                {{profile.contactEmail}}
              </section>
            </section>
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-map-marker" style="margin-right:.5em; color:grey"></i>
                {{profile.contactAddress}}
              </section>
              <section class="section-data">
                <i class="pi pi-phone" style="margin-right:.5em; color:grey"></i>
                {{profile.contactPhone}}
              </section>
            </section>
          </section>

          <div class="section-filters">
            <div class="grid-filters">
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="container-filter"
                    [options]="containerFilter"
                    (onChange)="changeFilter()"
                    [filter]="true"
                    [(ngModel)]="selectedContainers"
                    optionValue="value"
                    optionLabel="label"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="container-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.containerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="week-filter"
                    [options]="weekFilter"
                    [(ngModel)]="selectedWeeks"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="week-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.weekFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="importer-filter"
                    [options]="importerFilter"
                    [(ngModel)]="selectedCompanies"
                    [filter]="true"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="importer-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.importerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="specie-filter"
                    [options]="specieFilter"
                    [(ngModel)]="selectedSpecies"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="specie-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.specieFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="variety-filter"
                    [options]="varietyFilter"
                    [(ngModel)]="selectedVarieties"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="variety-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.varietyFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="ship-filter"
                    [options]="shipFilter"
                    [(ngModel)]="selectedShip"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="ship-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.naveFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="program-filter"
                    [options]="numberProgramsFilter"
                    [(ngModel)]="selectedPrograms"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="program-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.programFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="transport-filter"
                    [options]="transportSelect"
                    [optionLabel]="this.lang == 'es' ? 'nameEs' : 'nameEn'"
                    optionValue="value"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    [(ngModel)]="selectedTransportTypes"
                    class="multiselect"
                    />
                    <label for="transport-filter">
                      {{'UserPages.UserLoadMasterOrders.filters.transportFilter' | translate}}
                    </label>
                  </span>
                </div>
                <div class="dropdown-container">
                  <span class="p-float-label">
                    <p-multiSelect
                    id="year-filter"
                    [options]="years"
                    [(ngModel)]="yearSelect"
                    class="multiselect"
                    [selectionLimit]="1"
                    (onChange)="changeFilter()"
                    placeholder="{{'MyLoadFilter.SelectYear' | translate}}"
                    >
                    </p-multiSelect>
                    <label for="year-filter">
                      {{'MyLoadFilter.YearLabel' | translate}}
                    </label>
                  </span>
                </div>
            </div>
          </div>
        </div>

        <div class="container-table">
          <div  class="section-table">
            <p-table
              #loadContainersTable
              [value]="containerLoads"
              dataKey="product.pallet.id"
              [loading]="loading"
              [paginator]="true"
              [rows]="100"
              [rowsPerPageOptions]="[100, 200, 500, 1000]"
              [scrollable]="true"
              [lazy]="true"
              [totalRecords]="totalCount"
              (onLazyLoad)="loadContainerPage($event)"
              [resizableColumns]="true"
              columnResizeMode="expand"
              scrollHeight="800px"
              [tableStyle]="{ 'min-width': '50rem' }"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} resultados"
              styleClass="p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ProgramOrderIdHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ProgramName' | translate }}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ImportOrderIdHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ImporterHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.WeeksHeader' | translate}}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TransportTypeHeader' | translate }}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.OriginPortHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.OriginAirport' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.OriginCityHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ETDHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ArrivalPort' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.DestinationAirport' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.DestinationCityHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ETAHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ExporterInstructive' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ShippingCompany' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.VesselName' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ReceiverName' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ConsigneeName' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ContainerHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.Hatch' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.Cases' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.DestinationPlantName' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.DepartureCountry' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ArrivalCountry' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ArrivalContinent' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.MBL' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.BLNoHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.BookingNoHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.DUS' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.OriginCountryHeader' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.directSaleProgramId.toString() }}</td>
                  <td>{{ product.programName }}</td>
                  <td>{{ product.importOrderId }}</td>
                  <td>{{ product.importer }}</td>
                  <td>{{ product.week }}</td>
                  <td>{{ getTransportName(product.transportType) }}</td>
                  <td>{{ product.departurePort }}</td>
                  <td>{{ product.departureAirport }}</td>
                  <td>{{ product.departureCity }}</td>
                  <td>{{ product.etd | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ product.destinationPort }}</td>
                  <td>{{ product.destinationAirport }}</td>
                  <td>{{ product.destinationCity }}</td>
                  <td>{{ product.eta | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ product.exporterInstructive }}</td>
                  <td>{{ product.shippingCompany }}</td>
                  <td>{{ product.ship }}</td>
                  <td>{{ product.receiverName }}</td>
                  <td>{{ product.consigneeName }}</td>
                  <td>{{ product.containerNumber }}</td>
                  <td>{{ product.hatch }}</td>
                  <td>{{ product.cases }}</td>
                  <td>{{ product.destinationPlantName }}</td>
                  <td>{{ product.departureCountry }}</td>
                  <td>{{ product.arrivalCountry }}</td>
                  <td>{{ product.arrivalContinent }}</td>
                  <td>{{ product.mbl }}</td>
                  <td>{{ product.bl }}</td>
                  <td>{{ product.booking }}</td>
                  <td>{{ product.dus }}</td>
                  <td>{{ product.originCountry }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>

    </div>
  </div>
</app-user-dashboard>
